module.exports = __webpack_public_path__ + "static/12-4084cda25e111fdb8c72d3681de9c315.jpeg";